/**
 * Hit again › Sends: what each hit-again drop of the chain sends for this
 * container's amount, as number chips — 1st 1,250 → 2nd 1,563 (no
 * ordinal when it is sent again once; "→ …" when the chain has no limit) —
 * with the base it starts from. The texts it sends are the next row (HitTextsRow).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, Fragment } from 'react';
import { ArrowRight, Send } from 'lucide-react';
import { hitLadder } from '@trafficpulse/shared';

import type { DraftHitAgain } from '../../../../../drop-generator.types';
import { hitActionOf } from '../../../state/satellites/hit-again-draft';
import { HitRow } from './HitGrid';
import { ordinal } from './ordinal';

const SHOWN = 6;
const n = (x: number) => x.toLocaleString('en-US');

export const HitSendsRow: FC<{ hitAgain: DraftHitAgain; defaultAmount: number }> = ({ hitAgain, defaultAmount }) => {
  const ladder = hitLadder(hitActionOf(hitAgain), { drop: defaultAmount, base: defaultAmount });
  const shown = ladder.slice(0, SHOWN);
  return (
    <HitRow icon={Send} label="Sends" testId="hit-ladder" note={`The SMS of each new drop, for a drop of ${n(defaultAmount)} SMS (this container's amount).`}>
      {shown.map((value, i) => (
        <Fragment key={i}>
          {i > 0 ? <ArrowRight className="h-3.5 w-3.5 text-muted-foreground/60" aria-hidden /> : null}
          <span className="inline-flex h-8 items-center gap-1.5 rounded-lg border border-success/25 bg-success/10 px-2.5 text-[13px]" data-testid="hit-step">
            {ladder.length > 1 ? <span className="text-xs text-muted-foreground">{ordinal(i + 1)}</span> : null}
            <span className="font-mono font-semibold tabular-nums text-foreground">{n(value)}</span>
          </span>
        </Fragment>
      ))}
      {ladder.length > SHOWN ? <span className="text-xs text-muted-foreground">+{ladder.length - SHOWN} more</span> : null}
      {hitAgain.maxTimes === null ? (
        <>
          <ArrowRight className="h-3.5 w-3.5 text-muted-foreground/60" aria-hidden />
          <span className="text-[13px] text-muted-foreground" data-testid="hit-open">… while it hits</span>
        </>
      ) : null}
    </HitRow>
  );
};
